import { render } from "./IconPlus2.vue?vue&type=template&id=72351445&ts=true"
import script from "./IconPlus2.vue?vue&type=script&lang=ts"
export * from "./IconPlus2.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__